import React from "react";
import OrgChart from "react-orgchart";
import "react-orgchart/index.css";
import "./organogram.css";
import InsideHeader from "../../../components/InsideHeader";

const Organogram = () => {
  const initechOrg = {
    name: "Managing Director",
    image: "https://www.w3schools.com/howto/img_avatar.png",
    children: [
      {
        name: "Finance Manager",
        image: "https://www.w3schools.com/howto/img_avatar.png",
        children: [
          {
            name: "COST & MANAGEMENT ACCOUNTS",
            image: "https://www.w3schools.com/howto/img_avatar.png",
          },
          {
            name: "FINANCIAL ACCOUNTS",
            image: "https://www.w3schools.com/howto/img_avatar.png",
          },
          {
            name: "INTERNAL AUDIT",
            image: "https://www.w3schools.com/howto/img_avatar.png",
          },
        ],
      },
      {
        name: "Commercial Manager",
        image: "https://www.w3schools.com/howto/img_avatar.png",
        children: [
          {
            name: "CREDIT CONTROL SECTION",
            image: "https://www.w3schools.com/howto/img_avatar.png",
          },
          {
            name: "BILLING SECTION",
            image: "https://www.w3schools.com/howto/img_avatar.png",
          },
          {
            name: "CUSTOMER CARE SECTION",
            image: "https://www.w3schools.com/howto/img_avatar.png",
          },
        ],
      },
      {
        name: "Humana Resource Manager",
        image: "https://www.w3schools.com/howto/img_avatar.png",
        children: [
          {
            name: "Administration Section",
            image: "https://www.w3schools.com/howto/img_avatar.png",
          },
          {
            name: "Payroll Account",
            image: "https://www.w3schools.com/howto/img_avatar.png",
          },
        ],
      },
      {
        name: "ICT Manager",
        image: "https://www.w3schools.com/howto/img_avatar.png",
      },
      {
        name: "Procurement Manager",
        image: "https://www.w3schools.com/howto/img_avatar.png",
        children: [
          {
            name: "Procurement Section",
            image: "https://www.w3schools.com/howto/img_avatar.png",
          },
          {
            name: "Store Section",
            image: "https://www.w3schools.com/howto/img_avatar.png",
          },
        ],
      },
    ],
  };

  const MyNodeComponent = ({ node }) => {
    return (
      <div id="initechOrgChart" className="initechNode">
        <div className="flex flex-col gap-y-1 items-center">
          <img
            src={node?.image}
            className="w-[50%] h-[50%] rounded-full"
            alt="avatar"
          />
          {node.name}
        </div>
      </div>
    );
  };

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Organization Organogram"
        subtitle="Have a view of your oragnization organogram"
        back={false}
      />
      <div className="flex overflow-x-auto h-full mt-[1.25rem]">
        <OrgChart tree={initechOrg} NodeComponent={MyNodeComponent} />
      </div>
    </div>
  );
};

export default Organogram;
